import styled from 'styled-components';
import { MenuButton } from '@szhsin/react-menu';

export const ProfilePage = styled.div`
  width: 100%;
  max-width: 1152px;
  padding: 32px 24px 48px;
  color: var(--white);

  @media (min-width: 1024px) {
    padding: 40px 40px 56px;
  }

  .back {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 24px;
    border: 0;
    background: transparent;
    color: #a0a0a0;
    font-size: 14px;
    cursor: pointer;

    &:hover {
      color: var(--white);
    }
  }

  .hero {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 32px;

    @media (min-width: 640px) {
      flex-direction: row;
      align-items: flex-start;
    }
  }

  .avatar {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: rgba(3, 160, 141, 0.12);
    color: var(--primary);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .hero-meta {
    flex: 1;
    min-width: 0;

    h1 {
      margin: 0 0 8px;
      font-size: 30px;
      font-weight: 700;
      color: var(--white);
    }

    .desc {
      margin: 0 0 12px;
      max-width: 640px;
      font-size: 15px;
      line-height: 22px;
      color: #a0a0a0;
    }

    .id-row {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px 16px;
      font-size: 12px;
      color: #707070;

      .mono {
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        color: #a0a0a0;
        word-break: break-all;
      }
    }
  }

  .edit-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid #262626;
    background: transparent;
    color: var(--white);
    font-size: 14px;
    cursor: pointer;

    &:hover {
      border-color: #333;
    }
  }

  .grid {
    display: grid;
    gap: 24px;

    @media (min-width: 1024px) {
      grid-template-columns: 2fr 1fr;
    }
  }

  .stack {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .card {
    padding: 20px;
    border-radius: 12px;
    background: #161616;
    border: 1px solid #262626;
  }

  .card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;

    .title {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      color: var(--white);

      svg {
        color: var(--primary);
      }
    }

    .badge {
      font-size: 12px;
      padding: 2px 8px;
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.05);
      color: #a0a0a0;
    }
  }

  .instructions {
    margin: 0;
    font-size: 14px;
    line-height: 22px;
    color: #c0c0c0;
    white-space: pre-line;
  }

  .memory-item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 12px;
    border-radius: 8px;
    background: #0e0e0e;
    border: 1px solid #262626;

    & + & {
      margin-top: 12px;
    }

    .text {
      margin: 0;
      font-size: 14px;
      color: var(--white);
      word-break: break-word;
    }

    .date {
      margin: 4px 0 0;
      font-size: 12px;
      color: #707070;
    }

    .cats {
      display: flex;
      align-items: center;
      gap: 6px;
      flex-shrink: 0;
    }

    .cat {
      font-size: 12px;
      padding: 2px 8px;
      border-radius: 999px;
      background: rgba(3, 160, 141, 0.12);
      color: var(--primary);
      border: 1px solid rgba(3, 160, 141, 0.2);
    }

    .more {
      font-size: 12px;
      padding: 2px 8px;
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.05);
      color: #a0a0a0;
      border: 0;
      cursor: pointer;
    }
  }

  .config-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid #262626;

    &:last-child {
      border-bottom: 0;
    }

    .label {
      font-size: 14px;
      color: #808080;
    }

    .value {
      font-size: 14px;
      font-weight: 500;
      color: var(--white);
      text-align: right;
      word-break: break-all;
    }

    .pill {
      font-size: 12px;
      padding: 2px 8px;
      border-radius: 999px;
      border: 1px solid #262626;
      background: rgba(255, 255, 255, 0.05);
      color: #808080;

      &.on {
        background: rgba(3, 160, 141, 0.12);
        color: var(--primary);
        border-color: rgba(3, 160, 141, 0.2);
      }
    }
  }

  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    span {
      padding: 4px 10px;
      border-radius: 999px;
      font-size: 12px;
      background: rgba(16, 185, 129, 0.1);
      color: #10b981;
      border: 1px solid rgba(16, 185, 129, 0.2);
    }
  }
`;

export const MenuBtn = styled(MenuButton)`
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
`;

/** legacy */
export const StyledAgentProfile = styled.div``;
export const CardHolder = styled.div``;
